export const MESSAGES = {
  WAREHOUSE_NOT_ALLOWED: {
    title: 'Armazém Não Permitido',
    description: 'Este armazém não é válido para operações Natura'
  },
  
  INSTRUCTIONS: {
    title: 'Instruções para Upload de CSV',
    rules: [
      'O arquivo CSV deve conter exatamente três colunas: "SKU", "Quantidade" e "Custo"',
      'Os nomes das colunas devem ser exatos (não diferencia maiúsculas/minúsculas)',
      'O sistema detecta automaticamente o separador (vírgula, ponto e vírgula, tab ou pipe)',
      'SKU: identificador válido usando apenas letras, números, hífens (-) e underscores (_)',
      'Quantidade: deve ser um número inteiro positivo',
      'Custo: deve ser um número decimal positivo (ex: 15.50)',
      'Todas as linhas devem ter todas as colunas preenchidas'
    ]
  },
  
  BUTTONS: {
    downloadTemplate: 'Baixar Template CSV',
    clearData: 'Limpar Dados',
    saveReceiving: 'Salvar Recebimento',
    goToWarehouses: 'Ir para Lista de Armazéns',
    close: 'Fechar'
  },
  
  PLACEHOLDERS: {
    processing: 'Processando arquivo...',
    dragAndDrop: 'Clique ou arraste o arquivo CSV aqui'
  },
  
  ALERTS: {
    developmentFeature: 'Funcionalidade de salvar em desenvolvimento!'
  }
}

export const ERROR_MODAL = {
  title: 'Problemas encontrados no arquivo CSV',
  sections: {
    summary: 'Resumo do problema',
    errors: 'Erros encontrados',
    instructions: 'Como corrigir os problemas'
  }
} 